module.exports = __webpack_public_path__ + "static/media/colorProTrend.ca92777f.png";